import { render, staticRenderFns } from "./UserRoleBadge.vue?vue&type=template&id=ffabb7ba&"
import script from "./UserRoleBadge.vue?vue&type=script&lang=js&"
export * from "./UserRoleBadge.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports